// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2255":"3b1e880a","3561":"16db967f","3998":"c5875f8a","4621":"16db967f","5081":"16db967f","7712":"638f7377","9238":"3b1e880a"}[chunkId] + ".chunk.css";
};